/**
 * Instrument Rights API Endpoints
 *
 * Rights are scoped per-instrument and identified by numeric `id`.
 */

export const RIGHTS_ENDPOINTS = {
  /** GET — list rights for an instrument, POST — create. */
  RIGHTS: (instrumentId: number) => `/instruments/${instrumentId}/rights`,

  /** GET — single right by id. */
  RIGHT_BY_ID: (instrumentId: number, id: number) => `/instruments/${instrumentId}/rights/${id}`,

  /** PUT — update right. */
  UPDATE_RIGHT: (instrumentId: number, id: number) => `/instruments/${instrumentId}/rights/${id}`,

  /** DELETE — remove right. */
  DELETE_RIGHT: (instrumentId: number, id: number) => `/instruments/${instrumentId}/rights/${id}`,
} as const;
